import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid } from '@material-ui/core'
import { Email, Sms } from '@material-ui/icons'
import { withRouter } from 'react-router-dom'
import Button from 'components/theme/Button'
import { createTaskWithContact } from 'actions/contacts/addOrEdit'
import { listTemplates } from 'actions/template'
import { SUCCESS } from 'utils/statusConstants'
import language from 'utils/vast-languagepack'

export default withRouter(
  connect(
    state => ({
      email: state.addOrEditContact.fields.email[0].value,
      phone: state.addOrEditContact.fields.phones[0].value,
      contactID: state.addOrEditContact.contactID,
      firstName: state.addOrEditContact.fields.first_name.value,
      lastName: state.addOrEditContact.fields.last_name.value,
      templateLoadStatus: state.loadStatus.templatesById,
    }),
    dispatch => bindActionCreators({ createTaskWithContact, listTemplates }, dispatch),
  )(
    class Tasks extends Component {
      render() {
        const {
          email,
          phone,
          contactID,
          createTaskWithContact,
          history,
          firstName,
          lastName,
        } = this.props

        return (
          <div>
            <div style={{ margin: '5px 0 20px 2px', fontSize: 12 }}>
              {language.contacts.add.helperText.taskDescription}
            </div>
            <Grid container spacing={24}>
              <Grid item>
                <Button
                  disabled={contactID === 'new' || !email.length}
                  color="secondary"
                  variant="outlined"
                  onClick={() => {
                    if (this.props.templateLoadStatus === SUCCESS) {
                      Promise.resolve(history.push('/tasks/new')).then(() =>
                        createTaskWithContact({
                          taskType: 'email',
                          contact: {
                            contactID,
                            value: contactID,
                            label: `${firstName} ${lastName}`,
                            key: `${contactID}SelectValue`,
                          },
                        }),
                      )} else {
                        this.props.listTemplates().then(() =>
                          Promise.resolve(history.push('/tasks/new')).then(() =>
                            createTaskWithContact({
                              taskType: 'email',
                              contact: {
                                contactID,
                                value: contactID,
                                label: `${firstName} ${lastName}`,
                                key: `${contactID}SelectValue`,
                              },
                            }),
                          ),
                        )
                      }
                    }
                  }
                >
                  <Email style={{ marginRight: 5 }} />
                  {language.contacts.add.contactTask.emailTaskBtton}
                </Button>
              </Grid>
              <Grid item>
                <Button
                  disabled={contactID === 'new' || !phone.length}
                  color="secondary"
                  variant="outlined"
                  onClick={() =>
                    Promise.resolve(history.push('/tasks/new')).then(() =>
                      createTaskWithContact({
                        taskType: 'sms',
                        contact: {
                          contactID,
                          value: contactID,
                          label: `${firstName} ${lastName}`,
                          key: `${contactID}SelectValue`,
                        },
                      }),
                    )
                  }
                >
                  <Sms style={{ marginRight: 5 }} />
                  {language.contacts.add.contactTask.smsTaskBtton}
                </Button>
              </Grid>
            </Grid>
          </div>
        )
      }
    },
  ),
)
